export default __webpack_public_path__ + "static/media/clouds.a5edb6be.svg";